import { render, staticRenderFns } from "./CourseTabs.vue?vue&type=template&id=15f33dac&"
import script from "./CourseTabs.vue?vue&type=script&lang=js&"
export * from "./CourseTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports